import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import config from '../config';

const server_URL = config.SERVER_URL;

const Page = () => {
  const { link,email } = useParams();
  
  const handlePage = async () => {
    try {
      const response = await fetch(`${server_URL}/api/page`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ 'email':email, 'link':link }),
      });

      const data = await response.json();

      if (data.status == '1') {
        openWebsite(data.url);
      }
    } catch (error) {
      console.error('Error:', error);
    }
  };
  const openWebsite = (url) => {
      const fullUrl = url.startsWith('http') ? url : `https://${url}`;
      window.location.replace(fullUrl);
  };
  
  useEffect(() => {
    handlePage();
  }, []);

  
  return (
    <div style={{ 
      fontFamily: 'Arial, sans-serif', 
      backgroundColor: '#f4f4f4', 
      margin: 0, 
      padding: 0, 
      textAlign: 'center',
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }}>
      <div style={{ 
        maxWidth: '500px', 
        background: 'white', 
        margin: '50px auto', 
        padding: '20px', 
        borderRadius: '8px', 
        boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)'
      }}>
        <h2 style={{ color: '#333' }}>
          Loading...
        </h2>
       
        <br />
      </div>
    </div>
  );
};

export default Page; 